(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["index~tag"],{

/***/ 151:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/babel-helper-vue-jsx-merge-props/index.js
var babel_helper_vue_jsx_merge_props = __webpack_require__(3);
var babel_helper_vue_jsx_merge_props_default = /*#__PURE__*/__webpack_require__.n(babel_helper_vue_jsx_merge_props);

// EXTERNAL MODULE: ./node_modules/omit.js/es/index.js
var es = __webpack_require__(13);

// EXTERNAL MODULE: ./src/utils/css_animation/Event.js
var Event = __webpack_require__(36);

// EXTERNAL MODULE: ./src/utils/raf.js
var raf = __webpack_require__(37);

// EXTERNAL MODULE: ./src/base/config-provider/index.jsx + 1 modules
var config_provider = __webpack_require__(8);

// CONCATENATED MODULE: ./src/utils/wave.jsx



var styleForPesudo; // Where el is the DOM element you'd like to test for visibility

function isHidden(element) {
  if (false) {}

  return !element || element.offsetParent === null;
}

function isNotGrey(color) {
  // eslint-disable-next-line no-useless-escape
  var match = (color || '').match(/rgba?\((\d*), (\d*), (\d*)(, [\.\d]*)?\)/);

  if (match && match[1] && match[2] && match[3]) {
    return !(match[1] === match[2] && match[2] === match[3]);
  }

  return true;
}

/* harmony default export */ var wave = ({
  name: 'Wave',
  props: ['insertExtraNode'],
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      var node = _this.$el;

      if (node.nodeType !== 1) {
        return;
      }

      _this.instance = _this.bindAnimationEvent(node);
    });
  },
  inject: {
    configProvider: {
      default: function _default() {
        return config_provider["ConfigConsumerProps"];
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.instance) {
      this.instance.cancel();
    }

    if (this.clickWaveTimeoutId) {
      clearTimeout(this.clickWaveTimeoutId);
    }

    this.destroy = true;
  },
  methods: {
    onClick: function onClick(node, waveColor) {
      if (!node || isHidden(node) || node.className.indexOf('-leave') >= 0) {
        return;
      }

      var insertExtraNode = this.$props.insertExtraNode;
      this.extraNode = document.createElement('div');
      var extraNode = this.extraNode;
      extraNode.className = 'meg-click-animating-node';
      var attributeName = this.getAttributeName();
      node.removeAttribute(attributeName);
      node.setAttribute(attributeName, 'true'); // Not white or transparent or grey

      styleForPesudo = styleForPesudo || document.createElement('style');

      if (waveColor && waveColor !== '#ffffff' && waveColor !== 'rgb(255, 255, 255)' && isNotGrey(waveColor) && !/rgba\(\d*, \d*, \d*, 0\)/.test(waveColor) && // any transparent rgba color
      waveColor !== 'transparent') {
        // Add nonce if CSP exist
        if (this.csp && this.csp.nonce) {
          styleForPesudo.nonce = this.csp.nonce;
        }

        extraNode.style.borderColor = waveColor;
        styleForPesudo.innerHTML = "\n        [meg-click-animating-without-extra-node='true']::after, .meg-click-animating-node {\n          --meg-wave-shadow-color: ".concat(waveColor, ";\n        }");

        if (!document.body.contains(styleForPesudo)) {
          document.body.appendChild(styleForPesudo);
        }
      }

      if (insertExtraNode) {
        node.appendChild(extraNode);
      }

      Event["a" /* default */].addStartEventListener(node, this.onTransitionStart);
      Event["a" /* default */].addEndEventListener(node, this.onTransitionEnd);
    },
    onTransitionStart: function onTransitionStart(e) {
      if (this.destroy) return;
      var node = this.$el;

      if (!e || e.target !== node) {
        return;
      }

      if (!this.animationStart) {
        this.resetEffect(node);
      }
    },
    onTransitionEnd: function onTransitionEnd(e) {
      if (!e || e.animationName !== 'fadeEffect') {
        return;
      }

      this.resetEffect(e.target);
    },
    getAttributeName: function getAttributeName() {
      var insertExtraNode = this.$props.insertExtraNode;
      return insertExtraNode ? 'meg-click-animating' : 'meg-click-animating-without-extra-node';
    },
    bindAnimationEvent: function bindAnimationEvent(node) {
      var _this2 = this;

      if (!node || !node.getAttribute || node.getAttribute('disabled') || node.className.indexOf('disabled') >= 0) {
        return;
      }

      var onClick = function onClick(e) {
        // Fix radio button click twice
        if (e.target.tagName === 'INPUT' || isHidden(e.target)) {
          return;
        }

        _this2.resetEffect(node); // Get wave color from target


        var waveColor = getComputedStyle(node).getPropertyValue('border-top-color') || // Firefox Compatible
        getComputedStyle(node).getPropertyValue('border-color') || getComputedStyle(node).getPropertyValue('background-color');
        _this2.clickWaveTimeoutId = window.setTimeout(function () {
          return _this2.onClick(node, waveColor);
        }, 0);
        raf["a" /* default */].cancel(_this2.animationStartId);
        _this2.animationStart = true; // Render to trigger transition event cost 3 frames. Let's delay 10 frames to reset this.

        _this2.animationStartId = Object(raf["a" /* default */])(function () {
          _this2.animationStart = false;
        }, 10);
      };

      node.addEventListener('click', onClick, true);
      return {
        cancel: function cancel() {
          node.removeEventListener('click', onClick, true);
        }
      };
    },
    resetEffect: function resetEffect(node) {
      if (!node || node === this.extraNode || !(node instanceof Element)) {
        return;
      }

      var insertExtraNode = this.$props.insertExtraNode;
      var attributeName = this.getAttributeName();
      node.setAttribute(attributeName, 'false'); // edge has bug on `removeAttribute` #14466

      if (styleForPesudo) {
        styleForPesudo.innerHTML = '';
      }

      if (insertExtraNode && this.extraNode && node.contains(this.extraNode)) {
        node.removeChild(this.extraNode);
      }

      Event["a" /* default */].removeStartEventListener(node, this.onTransitionStart);
      Event["a" /* default */].removeEndEventListener(node, this.onTransitionEnd);
    }
  },
  render: function render() {
    if (this.configProvider.csp) {
      this.csp = this.configProvider.csp;
    }

    return this.$slots.default && this.$slots.default[0];
  }
});
// EXTERNAL MODULE: ./src/utils/props_util.js
var props_util = __webpack_require__(1);

// EXTERNAL MODULE: ./src/utils/BaseMixin.js
var BaseMixin = __webpack_require__(4);

// EXTERNAL MODULE: ./src/utils/index.js
var utils = __webpack_require__(6);

// CONCATENATED MODULE: ./src/components/tag/tag.jsx


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






 // 样式文件
// import './style/index.scss';

var PresetColorTypes = ['pink', 'red', 'yellow', 'orange', 'cyan', 'green', 'blue', 'purple', 'geekblue', 'magenta', 'gold', 'lime'];
var PresetColorRegex = new RegExp("^(".concat(PresetColorTypes.join('|'), ")(-inverse)?$"));
/* harmony default export */ var tag_tag = ({
  name: 'MegTag',
  mixins: [BaseMixin["a" /* default */]],
  model: {
    prop: 'visible',
    event: 'close.visible'
  },
  props: {
    prefixCls: utils["d" /* vueTypes */].string,
    color: utils["d" /* vueTypes */].string,
    closable: utils["d" /* vueTypes */].bool.def(false),
    visible: utils["d" /* vueTypes */].bool
  },
  inject: {
    configProvider: {
      default: function _default() {
        return config_provider["ConfigConsumerProps"];
      }
    }
  },
  data: function data() {
    var isVisible = true;
    var props = Object(props_util["getOptionProps"])(this);

    if ('visible' in props) {
      isVisible = this.visible;
    }

    return {
      isVisible: isVisible
    };
  },
  watch: {
    visible: function visible(val) {
      this.setState({
        isVisible: val
      });
    }
  },
  methods: {
    setVisible: function setVisible(visible, e) {
      this.$emit('close', e);
      this.$emit('close.visible', false);

      if (e.defaultPrevented) {
        return;
      }

      if (!Object(props_util["hasProp"])(this, 'visible')) {
        this.setState({
          isVisible: visible
        });
      }
    },
    handleIconClick: function handleIconClick(e) {
      e.stopPropagation();
      this.setVisible(false, e);
    },
    isPresetColor: function isPresetColor() {
      var color = this.$props.color;

      if (!color) {
        return false;
      }

      return PresetColorRegex.test(color);
    },
    getTagStyle: function getTagStyle() {
      var color = this.$props.color;
      var isPresetColor = this.isPresetColor();
      return {
        color: color && !isPresetColor ? color : undefined,
        backgroundColor: color && !isPresetColor ? "rgba(".concat(this.hexToRgb(color), ", .1)") : undefined
      };
    },
    hexToRgb: function hexToRgb(hex) {
      var color = [],
          rgb = [];
      hex = hex.replace(/#/, ""); // 处理 "#abc" 成 "#aabbcc"

      if (hex.length === 3) {
        var tmp = [];

        for (var i = 0; i < 3; i++) {
          tmp.push(hex.charAt(i) + hex.charAt(i));
        }

        hex = tmp.join("");
      }

      for (var _i = 0; _i < 3; _i++) {
        color[_i] = "0x" + hex.substr(_i * 2, 2);
        rgb.push(parseInt(Number(color[_i]), 10));
      }

      return rgb.join(",");
    },
    getTagClassName: function getTagClassName(prefixCls) {
      var _ref;

      var color = this.$props.color;
      var isPresetColor = this.isPresetColor();
      return _ref = {}, _defineProperty(_ref, prefixCls, true), _defineProperty(_ref, "".concat(prefixCls, "-").concat(color), isPresetColor), _defineProperty(_ref, "".concat(prefixCls, "-has-color"), color && !isPresetColor), _ref;
    },
    renderCloseIcon: function renderCloseIcon() {
      var h = this.$createElement;
      var closable = this.$props.closable;
      return closable ? h("meg-icon", {
        "class": "meg-tag-delete",
        attrs: {
          original: true,
          name: "megui-close",
          width: "10px",
          height: "10px"
        },
        on: {
          "click": this.handleIconClick
        }
      }) : null;
    }
  },
  render: function render() {
    var h = arguments[0];
    var customizePrefixCls = this.$props.prefixCls;
    var getPrefixCls = this.configProvider.getPrefixCls;
    var prefixCls = getPrefixCls('tag', customizePrefixCls);
    var visible = this.$data.isVisible;
    var tag = h("span", babel_helper_vue_jsx_merge_props_default()([{
      directives: [{
        name: "show",
        value: visible
      }]
    }, {
      on: Object(es["a" /* default */])(Object(props_util["getListeners"])(this), ['close'], ['click'])
    }, {
      "class": this.getTagClassName(prefixCls),
      style: this.getTagStyle()
    }]), [this.$slots.default, this.renderCloseIcon()]);
    var transitionProps = Object(utils["b" /* getTransitionProps */])("".concat(prefixCls, "-zoom"), {
      appear: false
    });
    return h(wave, [h("transition", transitionProps, [tag])]);
  }
});
// EXTERNAL MODULE: ./src/base/base/index.js
var base = __webpack_require__(19);

// CONCATENATED MODULE: ./src/components/tag/index.jsx



tag_tag.install = function (Vue) {
  Vue.use(base["a" /* default */]);
  Vue.component(tag_tag.name, tag_tag);
};

/* harmony default export */ var components_tag = __webpack_exports__["default"] = (tag_tag);

/***/ })

}]);